import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { documentsApi } from '@/domain/documents/api';
import { queryOptions } from '@/services/query';

import { documentsKeys } from '@/domain/documents/queries/keys';

export const paymentEligibilityQuery = (companyId: string, documentId: string) =>
  queryOptions({
    queryKey: documentsKeys.paymentEligibility(companyId, documentId),
    queryFn: () => documentsApi.checkPaymentEligibility({ query: { documentID: documentId } }),
  });

export const usePaymentEligibility = (documentId: string, enabled = true) => {
  const { companyId } = useParams();
  return useQuery({
    ...paymentEligibilityQuery(companyId ?? '', documentId),
    enabled: enabled && Boolean(companyId) && Boolean(documentId),
  });
};
